import * as actionTypes from "~/store/action_types";

const discussionsData = (state = {}, action) => {
  switch (action.type) {
    case actionTypes.ADD_DISCUSSION_SUCCESS:
    case actionTypes.FETCH_DISCUSSION_SUCCESS: {
      const { response = {} } = action;
      const { result = {} } = response;
      const { single: id, participants = [] } = result;
      if (!id) {
        return state;
      }
      return {
        ...state,
        [id]: {
          is_read: true,
          participants: participants,
        },
      };
    }
    case actionTypes.PREFETCH_DISCUSSION_SUCCESS: {
      const { response = {} } = action;
      const { result = {} } = response;
      const { single: id = 0, participants = [] } = result;
      if (!id) {
        return state;
      }
      return {
        ...state,
        [id]: {
          ...state[id],
          participants: participants,
        },
      };
    }
    case actionTypes.FETCH_DISCUSSION_READ_STATUSES_SUCCESS: {
      const { response = {} } = action;

      Object.keys(response).forEach((id) => {
        state = {
          ...state,
          [id]: {
            ...state[id],
            is_read: response[id],
          },
        };
      });

      return state;
    }
    case actionTypes.FETCH_DISCUSSIONS_SUCCESS: {
      if (!action.response || !action.response.entities || !action.response.entities.discussions) {
        return state;
      }
      const data = Object.values(action.response.entities.discussions).reduce((acc, discussion) => {
        acc[discussion.id] = {
          participants: discussion.participants,
          is_read: discussion.is_read,
        };
        return acc;
      }, {});
      return {
        ...state,
        ...data,
      };
    }

    case actionTypes.ADD_COMMENT_SUCCESS: {
      const { response = {} } = action;
      const { entities = {}, result = {} } = response;
      const { comments = {} } = entities;
      const { single } = result;
      const comment = comments[single];
      if (action.parentType === "Discussion" && action.parentId && comment) {
        return {
          ...state,
          [action.parentId]: {
            is_read: state[action.parentId]?.is_read,
            participants: [...(state[action.parentId]?.participants ?? []), comment.created_by_id],
          },
        };
      }
      return state;
    }
    case actionTypes.ADD_COMMENT_FROM_EVENT_STREAM_SUCCESS: {
      const { response = {} } = action;
      const { entities = {}, result = 0 } = response;
      const { comments = {} } = entities;
      const comment = comments[result];
      if (action.parentType === "Discussion" && action.parentId && comment) {
        const previous = state[action.parentId]?.participants || [];
        const participants = [...new Set([...previous, comment.created_by_id])];
        return {
          ...state,
          [action.parentId]: {
            is_read: action.loggedUserId === comment.created_by_id,
            participants: participants,
          },
        };
      }
      return state;
    }
    case actionTypes.ADD_DISCUSSION_FROM_EVENT_STREAM:
    case actionTypes.DISCUSSION_MOVED_TO_PROJECT_FROM_EVENT_STREAM: {
      const { response = {} } = action;
      const { entities = {}, result: id = 0 } = response;
      const { discussions = {} } = entities;

      if (id && discussions[id]) {
        return {
          ...state,
          [id]: {
            is_read: false,
            participants: discussions[id].participants,
          },
        };
      }
      return state;
    }
    case actionTypes.UPDATE_DISCUSSION_FROM_EVENT_STREAM:
    case actionTypes.RESTORE_DISCUSSION_FROM_TRASH_FROM_EVENT_STREAM: {
      const { response = {} } = action;
      const { entities = {}, result: id = 0 } = response;
      const { discussions = {} } = entities;
      const previous = state[id];
      if (id && discussions[id]) {
        return {
          ...state,
          [id]: {
            ...previous,
            participants: discussions[id].participants,
          },
        };
      }
      return state;
    }
    default: {
      return state;
    }
  }
};

export default discussionsData;
